import React, { useState, useEffect } from 'react'
import { NavLink } from 'react-router-dom';
import { useNavigate,useParams} from 'react-router-dom';
import { format } from 'date-fns';
import OtpInput from 'react-otp-input';
import "react-custom-flag-select/lib/react-custom-flag-select.min.css";
import './css/style.css';
import './css/login1.css';
import { subApi,unsubApi,prizeApi } from '../services/user-api';
import {service,serviceId,Loader,countryCode,flag} from "../utils/constant";

const Unsub = () => {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const { params } = useParams();
    const [ButtonDisabled, setButtonDisabled] = useState(true);
    const [phone, setPhone] = useState('');
    const [userPhone, setUserPhone] = useState('');
    const [message, setMessage] = useState({message: "",error: false});
    const [flow, setFlow] = useState('UNSUB');
    const [unsub, setUnsub] = useState(false);
    const [prizes, setPrizes] = useState([]);
    const [prizeId, setPrizeId] = useState([]);
    const [otp, setOtp] = useState('');
    const [otpId, setOtpId] = useState('');
    
      useEffect(() => {  
        if(service==='mtnet'){params?getPrize():setFlow('');}
    }, []);

    const unsubHit = async() => {
        setLoading(true);
        await unsubApi({action:2,serviceId:serviceId,mode:'WAP'}).then((res) => {
            setMessage({message: "You are successfully unsubscribed from the servce.",error: false})
            setUnsub(true); 
            sessionStorage.clear(); 
        }).catch((err) => {
            console.log(err)
            setMessage({message: err.message,error: true})
        }).finally(() => setLoading(false))
       
      };
      const redirect = async(input) => {
            console.log("redirect="+input +"::"+params);
            if(!!params)window.location.href = "/home";
            else setFlow(input);
        }
    const getPrize = async() => { 
           setFlow("PRIZE");    
           setLoading(true);    
           await prizeApi().then((res) => {        
                setPrizes(res.data.data);
                setLoading(false);  
            }).catch((err) => {
                console.log(err);
                setLoading(false);
            })
    };
    const setTransferId = async(input,num) => {
        setPrizeId(input);
        if(num && num.length>7)
        {
            var nm=num;if(nm.length>10)nm=nm.substring(3);
            setPhone(nm);
            setUserPhone(nm);
            setButtonDisabled(false);
        }
        setFlow("TRANSFER");
    }
    const handleNumberChange = async(event) =>{
        const input = event.target.value;
        if(input.length<11)setPhone(input);
        setButtonDisabled(input.length <8);
    }  
    const transferPoints = async() => {
        console.log("transfer="+prizeId);
        setLoading(true);
        var nm=phone;if(nm.length<10)nm=countryCode+nm
        await subApi({action:10,serviceId:serviceId,mode:'WAP',uid:prizeId,alias:nm}).then((res) => {
            console.log(res.data);
            setMessage({message: "Your prize money has been transferred.",error: false});  
        }).catch((err) => {
            console.log(err)
            setMessage({message: err.message,error: true})
        }).finally(() => setLoading(false))
    };
    const handleNumInputsChange = (numInputs) => {
        setOtp(numInputs);
        setButtonDisabled(numInputs.length !== 4 || isNaN(numInputs));
    }
    const sendOtp = async() => {
            console.log('phone='+userPhone);
            setMessage({message: "",error: false});
            if(userPhone && userPhone.length>=8)
            {
                var nm=userPhone;if(nm.length<=10)nm=countryCode+nm
                setLoading(true);
               await subApi({action:3,serviceId:serviceId,ani: nm}).then((res) => { 
                    setLoading(false);
                    setButtonDisabled(true);
                    setFlow("OTPCONFIRM");
                }).catch((err) => {
                    console.log(err);
                    setMessage({message: err.message, error: true });
                    setLoading(false);
                });
            }
            else if(phone && phone.length>0){setMessage({message: "Please enter a valid number",error: true})}
            else{setMessage({message: "Please enter a number",error: true})}
          };
        
    const confirmOtp = async() => {
            setMessage({message: "",error: false});     
            if(otp!=null && otp.length===4)
            {         
                var nm=userPhone;if(nm.length<=8)nm=countryCode+nm
                setLoading(true);
                await subApi({action:4,serviceId:serviceId,ani: nm,otpId:otpId,otp:otp}).then((res) => {  
                    // ########### hit transfer API ######### //                  
                    var nmm=phone;if(nmm.length<10)nmm=countryCode+nm
                    subApi({action:10,serviceId:serviceId,mode:'WAP',uid:prizeId,alias:nmm}).then((res) => {
                        console.log(res.data);
                        setMessage({message: "Your prize money has been transferd.",error: false});  
                    }).catch((err) => {
                        console.log(err)
                        setMessage({message: err.message,error: true})
                    }).finally(() => setLoading(false))
                    // ##################### END ############ //
                }).catch((err) => {
                    setMessage({message: err.message, error: true});
                }).finally(() => setLoading(false))
            }
            else{setMessage({ message:"OTP is not valid",error: true });}
          }     



    return (
        
            <div className='home'>
                <div className="maine-div">
                    <div className="container-fluid box-wrapper login"> 
                        <div className='pt-5'>                                                  
                            <div className="login-thumbnail">
                                 <img src="/images/uv_games_logo.png" alt="UVGames" />                            
                            </div>                    
                        </div>

                        <div className="login-header pb-4">
                            <div className="box-wrapper mx-auto text-center position-relative"> 
                                <span className="modal-level-title game-title">Welcome to UVGames</span>
                            </div>
                        </div>

                        <div className="login-info">
                            {(service==="mtnz" || service==="mtnet")?
                                <div className="login-thumbnail3">                            
                                <img src="/images/login_img_new.png" alt="UVGames" />
                                </div>  
                            :
                                <div className="login-thumbnail2">
                                    <img src="/images/login_img.png" alt="UVGames" />
                                </div>
                            }
                            {flow==="UNSUB"?(
                                <div> 
                                    {unsub?<>
                                        { message.message && <div className="mb-3"><p className={`alert alert-${message.error ? 'danger' : 'success'}`}>{message.message}</p></div>}
                                    </>
                                    :<>
                                         {service==='mtnet'?
                                            <NavLink onClick={() => {redirect('')}} className="send_otp_link" > &lt;&lt;&nbsp;Back</NavLink>
                                            :
                                            <NavLink to='/' className="send_otp_link" > &lt;&lt;&nbsp;Back</NavLink>
                                            }
                                        
                                        <h3 className="login-title mb-3 mt-3 text-center">To unsubscribe from the service, Click on unsub.</h3>
                                        {
                                            message.message && <div className="mb-3">
                                            <p className={`alert alert-${message.error ? 'danger' : 'success'}`}>{message.message}</p>
                                            </div>
                                        }
                                        {loading ? <Loader />: <button className="btn btn-primary btn-pm-custom" type="button" onClick={unsubHit}>Unsub</button>                      
                                        }
                                    </>}
                                </div>
                            ):flow==="TRANSFER"?(<>
                                 <NavLink onClick={() => {redirect('')}} className="send_otp_link" > &lt;&lt;&nbsp;Back</NavLink><br/>
                                <h3 className="header-title-green mb-3 mt-3 text-center">Enter Money App Number</h3>                        
                               <div className="phone-input">  
                                    <div className="has-validation input-group">
                                        <div className="dialing-code">
                                            <img src={"https://flagcdn.com/"+flag+".svg"} width="24" alt="Cameroon" />
                                            <span>+{countryCode}</span></div>
                                            <input                                    
                                            className="form-control form-mobile-no" 
                                            type="number" 
                                            inputMode="numeric" 
                                            value={phone?phone:''}
                                            onChange={handleNumberChange}
                                            placeholder="Enter Mobile Number"
                                        />             
                                        </div>                              
                                    {message.message && <div className="mb-3"><p className={`alert alert-${message.error ? 'danger' : 'success'}`}>{message.message}</p> </div>}                              
                                    {loading ? <Loader />:<button className="btn btn-primary btn-pm-custom" type="button" onClick={transferPoints} disabled={ButtonDisabled}>Submit</button>}
                                </div>
                            </>
                             ): flow === "OTPCONFIRM" ?(
                                <>
                                     <h3 className="login-title mb-3 mt-3 text-center">Enter OTP</h3>
                                     <div className="phone-info">
                                        <div className="otp_section">               
                                            <OtpInput
                                                value={otp}
                                                numInputs={4}
                                                renderInput={(props, index) => (
                                                    <input   {...props}  type="tel" inputMode="numeric" />
                                                )}
                                                inputStyle="form-control form-otp"
                                                onChange={handleNumInputsChange}
                                            />
                                        </div>
                                        {message.message && <div className="mb-3"><p className={`alert alert-${message.error ? 'danger' : 'success'}`}>{message.message}</p> </div>}
                                        {loading ? <Loader />:<button className="btn btn-primary btn-pm-custom" type="button" onClick={confirmOtp} disabled={ButtonDisabled}>Confirm</button>}
                                        <div className="resend_otp"><a className="send_otp_link" onClick={() => {setFlow('PRIZE')}}> &lt;&lt;&nbsp;Back</a></div>
                                    </div>
                                </>
                            ):flow==="PRIZE"?(<>
                                <NavLink onClick={() => {redirect('')}} className="send_otp_link" > &lt;&lt;&nbsp;Back</NavLink><br/>
                                <div className="box-wrapper mx-auto text-center position-relative"> 
                                     <span className="modal-level-title game-title">Prize Detail</span>
                                </div>
                                <hr/>
                                <section>
                                    <table className="table">
                                        <thead className="thead">
                                            <tr>
                                                <th scope="col">Month</th>
                                                <th scope="col">Points</th>
                                                <th scope="col">Prize</th>
                                                <th scope="col">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        {loading ? <Loader />:
                                                prizes.length > 0 ?
                                                prizes.map((prize, index) => {
                                                    return (
                                                        <tr key={prize.id}>
                                                            <td>{format(new Date(prize.createdAt), 'yyyy/MM')}</td>
                                                            <td>{prize.totalPoints}</td>
                                                            <td>{prize.prize}</td>
                                                            <td>{prize.payStatus===1?<>Withdrawn</>:
                                                            <> 
                                                            <NavLink onClick={() => {setTransferId(prize.id,prize.ani)}} className="send_otp_link_1" >Withdraw</NavLink>
                                                            </>}</td>
                                                        </tr>
                                                    )
                                                }):<>
                                                <tr key="tr1">
                                                <td colSpan={4}><span className="header-title-red">No prize available in your account.</span></td> 
                                                </tr>
                                                </>
                                            }
                                        </tbody>
                                    </table>
                                </section>
                            </>
                            ):(<>                                                              
                                <NavLink to='/' className="send_otp_link" > &lt;&lt;&nbsp;Back</NavLink><br/>
                                <button className="btn btn-primary btn-pm-theme" type="button" onClick={() => {redirect('UNSUB')}}>Unsubscribe</button>
                                <button className="btn btn-primary btn-pm-theme" type="button" onClick={() => {getPrize()}}>Withdraw Points</button>
                                
                            </>)
                            }
                        </div>                        
                    </div>
                </div>
            </div> 
       
    )
}

export default Unsub